import React from 'react'
import Attendance from './Attendance'
import './attendance.scss'
import {PanelWrapper} from 'components/UI'

class teacherAttendance extends React.Component {
	constructor(props) {
		super(props)


	}


  render() {
    return (
      <PanelWrapper>
        <Attendance state='teacher' {...this.props} />
      </PanelWrapper>
    )
  }
}

export default (teacherAttendance)



// WEBPACK FOOTER //
// ./src/containers/pages/Teacher/Attendance/index.js